import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  List,
  ListItem,
  Typography,
  IconButton,
  Grid
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/AddCircleTwoTone';
import RemoveIcon from '@material-ui/icons/RemoveCircleTwoTone';

import _ from 'lodash';

import { useSelector, useDispatch } from 'react-redux';

import withAlert from '../../../../hoc/withAlert';
import { correctNounForm } from '../../../../helpers/textHelper';

import { getMealSelector } from '../../../../store/meal';

import {
  addCoupon,
  deleteCoupon,
  changeCoupon,
  getTeamOrderCouponsSelector,
  getTeamTodayCouponsSelector
} from '../../../../store/team';
// import config from '../../../../config/config';
import teamService from '../../../../common/teamService';

import config from '../../../../config/config.json';

const useStyles = makeStyles(theme => ({
  nestedHead: {
    paddingLeft: theme.spacing(4)
  },
  nested: {
    paddingLeft: theme.spacing(6)
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  },
  listItemText: {
    fontSize: 13
  },
  listItemNumber: {
    fontSize: 13,
    fontWeight: 600
  }
}));

const Eating = props => {
  const {
    name,
    id,
    eventeatings,
    maxChecked,
    maxCheckedPoints,
    customerType,
    token,
    customerId,
    setSnackMessage,
    setSnackType,
    setOpenSnack
  } = props;

  const dispatch = useDispatch();
  const mealData = useSelector(getMealSelector);
  const classes = useStyles();

  // Подготовленный список блюд
  const [dishes, setDishes] = useState([]);
  const [currentPoints, setCurrentPoints] = useState(0);
  


  const orderCoupons = useSelector(getTeamOrderCouponsSelector);
  const todayOrderCoupons = useSelector(getTeamTodayCouponsSelector);

  useEffect(() => {
    if (eventeatings && eventeatings.length > 0) {
      const et = eventeatings.filter(e => e.eatingId === id);

      let eatingMeals = [];
      et.forEach(e => {
        e.meals.forEach(mealId => {
          eatingMeals.push({
            meal: mealData.filter(meal => meal.id === mealId)[0],
            id: e.id,
            date: e.date,
            eatingId: e.eatingId,
            meetingId: e.meetingId
          });
        });
      });
      eatingMeals = eatingMeals.filter(e => e.meal.isCombo !== 1);

      // Добавим данные из существующих купонов

      // Для бара всегда смотрим на сегодняшние купоны
      const orders = id !== config.mealsId.bar ? orderCoupons.filter(
        c => parseInt(c.eating_id) == parseInt(id)
      ) : todayOrderCoupons.filter(
        c => parseInt(c.eating_id) == parseInt(id)
      );

      const em = eatingMeals.reduce((result, e) => {
        const coupon = orders.filter(
          o => parseInt(o.meal_id) === parseInt(e.meal.id)
        );
        if (coupon.length > 0) {
          result.push({
            ...e,
            couponId: coupon[0].id,
            amount: coupon[0].amount
          });
          return result;
        } else {
          result.push({ ...e, couponId: null, amount: null });
          return result;
        }
      }, []);
      setDishes(em);

      // check is it possible to add more dishes
      setCurrentPoints(
        customerType === config.creditCustomerType
          ? creditRule(em)
          : staffRule(em)
      );

    }
  }, [eventeatings, orderCoupons, todayOrderCoupons]);

  // Правило проверки для сотрудников. Основанно на поинатх
  const staffRule = eventeating => {
    let checkedSum = eventeating.reduce((agg, dish) => {
      agg += dish.amount * dish.meal.points;
      return agg;
    }, 0);
    return checkedSum;
  };

  // Правило для кредиторов основанно на колве блюд
  const creditRule = eventeating => {
    let checkedSum = eventeating.reduce((agg, dish) => {
      agg += dish.amount;
      return agg;
    }, 0);
    return checkedSum;
  };

  const blockAddPoints = meal => {
    const isBlocked = teamService.isMealDisabled(meal.id, id)
    if (isBlocked) return true
  
    // Check that not more than possible total
    // const couponsToday = todayOrderCoupons.reduce((res, c) => {
    //   res +=  c.amount;
    //   return res
    // }, 0)
    // if (teamService.isBefore10()){
    //   if ((couponsToday + meal.points) > config.maxStaffPoints) return true
    // }


    if (customerType === config.creditCustomerType) {
      return currentPoints + 1 > maxChecked;
    } else {
      return currentPoints + meal.points > maxCheckedPoints;
    }
  };

  const handleChangeCoupon = async (eventeating, amount) => {
    try {
      const result = await dispatch(
        changeCoupon({
          mealId: eventeating.meal.id,
          date: eventeating.date,
          meetingId: eventeating.meetingId,
          eventeatingId: eventeating.id,
          eatingId: id,
          couponId: eventeating.couponId,
          token,
          customerId,
          amount
        })
      );

      if (result.type === 'api/callFailed') {
        setSnackMessage(`Ошибка: данные не сохранены`);
        setSnackType('error');
        setOpenSnack(true);
      } else {
        setSnackMessage('Данные сохранены');
        setSnackType('success');
        setOpenSnack(true);
      }
    } catch (error) {
      setSnackMessage(
        `Ошибка: ${error.response ? error.response.data.message : error}`
      );
      setSnackType('error');
      setOpenSnack(true);
    }
  };
  
  return (
    <React.Fragment>

      <List dense={true}>
        {/* Не показываем позиции у которых явно написанно в поинтах - 0 поинтов */}
        {dishes &&
          dishes
            .filter(d => d.isCombo !== 1 && d.meal.points > 0)
            .map(d => (
              <React.Fragment key={d.meal.id}>
                <ListItem>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    spacing={0}
                    wrap="nowrap">
                    <Grid item>
                      <IconButton
                        aria-label="minus"
                        disabled={!d.amount || teamService.isMealDisabled(d.meal.id, id)}
                        onClick={e => {
                          handleChangeCoupon(d, -1);
                        }}>
                        <RemoveIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <Typography variant="h3" style={{ fontSize: 14 }}>
                        {' '}
                        {d.amount ? d.amount : 0}{' '}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <IconButton
                        aria-label="add"
                        disabled={blockAddPoints(d.meal)}
                        onClick={e => {
                          handleChangeCoupon(d, 1);
                        }}>
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Grid>

                    <Grid item>
                      <Typography>{`${d.meal.name} ${
                        parseInt(customerType) !== config.creditCustomerType
                          ? `(${d.meal.points} ${correctNounForm(
                              d.meal.points,
                              ['балл', 'балла', 'баллов']
                            )})`
                          : ''
                      }`}</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              </React.Fragment>
            ))}
      </List>
    </React.Fragment>
  );
};

export default withAlert(Eating);
